import React, { useEffect, useState } from 'react';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import SecurityBadges from './components/SecurityBadges';
import LoginFooter from './components/LoginFooter';
import ContactSupportModal from './components/ContactSupportModal';

const Login = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  useEffect(() => {
    document.title = 'Sign In - ORIN';
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4 md:p-6 lg:p-8">
      <div className="w-full max-w-md lg:max-w-lg">
        <div className="bg-card rounded-lg md:rounded-xl shadow-lg border border-border p-6 md:p-8 lg:p-10">
          <LoginHeader />

          <div className="mt-6 md:mt-8">
            <LoginForm />
          </div>

          <div className="mt-8 md:mt-10">
            <SecurityBadges />
          </div>

          <LoginFooter />
        </div>

        <div className="mt-4 md:mt-6 text-center">
          <p className="text-xs md:text-sm text-muted-foreground font-caption">
            <button
              onClick={() => setIsContactModalOpen(true)}
              className="text-primary hover:text-primary/80 font-medium transition-smooth focus-ring rounded px-1"
            >
              Contact Support
            </button>
          </p>
        </div>
      </div>

      <ContactSupportModal 
        isOpen={isContactModalOpen} 
        onClose={() => setIsContactModalOpen(false)} 
      />
    </div>
  );
};

export default Login;